import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';

import { SECTION_KEYS } from '../../constants/sections';
import { useCheckout } from '../../hooks/useCheckout';
import CheckoutCard from '../CheckoutCard';
import EditView from './EditView';
import SummaryView from './SummaryView';

function MailingAddressCard({ hideEdit, sectionNumber }) {
  const { formState } = useFormContext();
  const { validSections } = useCheckout();

  const sectionKey = SECTION_KEYS.MAILING_ADDRESS;
  const isValid = validSections[sectionKey];

  const showSubtitle = !isValid && !formState.isSubmitted;

  // TODO: translate strings
  const title = 'Mailing Address';
  const subtitle = showSubtitle ? 'We need your mailing address.' : null;

  return (
    <CheckoutCard
      hideEdit={hideEdit}
      sectionKey={sectionKey}
      sectionNumber={sectionNumber}
      subtitle={subtitle}
      title={title}
    >
      <CheckoutCard.Summary>
        <SummaryView sectionKey={sectionKey} />
      </CheckoutCard.Summary>
      <CheckoutCard.Edit>
        <EditView sectionKey={sectionKey} />
      </CheckoutCard.Edit>
    </CheckoutCard>
  );
}

MailingAddressCard.propTypes = {
  hideEdit: PropTypes.bool,
  sectionNumber: PropTypes.number.isRequired
};

export default MailingAddressCard;
